<template>
  <van-swipe @change="onChange" :autoplay="3000" v-if="safeLst">
    <van-swipe-item v-for="(item,index) in safeLst" :key="index">
        <img v-lazy="item" class="banner_img"  />
    </van-swipe-item>
    <template #indicator>
      <div class="custom-indicator">
        <div class="point" :class="current == item ? 'show-point':''" v-for="item in safeLst.length" :key="item" />
      </div>
    </template>
  </van-swipe>
</template>

<script>
export default {
  name: 'ProductSwipeView',
  props: ['lst'],
  computed: {
    safeLst(){
        return this.lst || null
    }
  },
  data () {
    return {
      current: 1
    }
  },
  methods: {
    onChange (index) {
      this.current = index + 1
    }
  }
}
</script>
<style lang="scss" scoped>
.banner_img {
    width: 100%;
    height: calc(100vw * 108 / 97);
    object-fit: cover;
}
.custom-indicator {
    position: absolute;
    right: 10px;
    bottom: 10px;
    padding: 6px 8px;
    display: flex;
    gap: 8px;
    .point {
      width: 8px;
      height: 8px;
      background: gray;
      border-radius: 50%;
    }
    .show-point {
      background: #fff !important;
    }
}
</style>
